var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagfileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91142 7.60063L3.98767 9.67688C4.84017 10.5294 6.22434 10.5294 7.08142 9.67688L9.09351 7.66479C9.94601 6.81229 9.94601 5.42813 9.09351 4.57104L7.01267 2.49938C6.57726 2.06396 5.97684 1.83021 5.36267 1.86229L3.07101 1.97229C2.15434 2.01354 1.42559 2.74229 1.37976 3.65438L1.26976 5.94604C1.24226 6.56479 1.47601 7.16521 1.91142 7.60063Z",
    stroke: "#8493B2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35238 6.08464C4.9852 6.08464 5.49821 5.57163 5.49821 4.9388C5.49821 4.30598 4.9852 3.79297 4.35238 3.79297C3.71955 3.79297 3.20654 4.30598 3.20654 4.9388C3.20654 5.57163 3.71955 6.08464 4.35238 6.08464Z",
    stroke: "#8493B2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagfileicon);
export default __webpack_public_path__ + "static/media/tagfileicon.cfe12eacda023163f187709731aa2a23.svg";
export { ForwardRef as ReactComponent };